import { withDependencies } from '@wix/thunderbolt-ioc'
import { BuilderComponentRegistrarSymbol, BuilderComponentResolverSymbol } from './symbols'
import type { BuilderComponentRegistrar, BuilderComponentResolver } from './types'

const isSsr = !process.env.browser

export const builderComponentWillMount = withDependencies(
	[BuilderComponentResolverSymbol, BuilderComponentRegistrarSymbol],
	(BuilderComponentResolver: BuilderComponentResolver, builderComponentsRegistrar: BuilderComponentRegistrar) => {
		return {
			componentTypes: ['Builder'],
			async componentWillMount({ builderType }: { builderType: string }) {
				const {
					componentUrl,
					serverUrl,
					componentId: builderComponentId,
					appDefinitionId,
				} = BuilderComponentResolver.getBuilderComponentData({ builderType })

				const { loadAndRegisterComponent } = builderComponentsRegistrar

				const loadAndFetchComponentPromise = loadAndRegisterComponent({
					builderComponentId,
					builderType,
					componentUrl: isSsr && serverUrl ? serverUrl : componentUrl,
					appDefinitionId,
				})

				await Promise.all([loadAndFetchComponentPromise])
			},
		}
	}
)
